<div class="container-fluid bg-white">

  <app-loader *ngIf="isLoading()"></app-loader>

  <div class="page" *ngIf="!isLoading()">

    <div class="page-body">

      <div class="container-section">

        <div class="container-smaller">

          <div class="content-wrapper">

            <div class="content">

              <div class="entity-single">

                <div class="row">

                  <div class="col-12 col-sm-7 column-left">

                    <h1 class="page-title entity-title alternate-heading">
                      {{getTranslatedTitle(entity)}}
                    </h1>

                    <span class="entity-content" [innerHTML]="getTranslatedContent(entity) | safeHtml"></span>

                  </div>

                  <div class="col-12 col-sm-5 column-right">

                    <div class="image-main entity-image-main">
                      <img class="img-fluid" [src]="entity.imageUri" />
                    </div>

                    <!-- image gallery thumbnails -->
                    <div class="image-thumbnails-wrapper mt-3" *ngIf="entity.imageReferences && entity.imageReferences.length>0">
                      <div class="row">
                        <div class="col-sm-6 cursor-pointer" [ngClass]="{'d-none': image['imageType'] != externalpageImageTypes.GalleryImage}" *ngFor="let image of entity.imageReferences" (click)="imageService.openImage(image.imageUri, entity.title)">
                          <img class="img-fluid image-thumb" [src]="image['imageUri']" />
                        </div>
                      </div>
                    </div>

                  </div>

                </div>

              </div>


            </div>

          </div>

        </div>

      </div>

    </div>

  </div>

</div>
